import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  updatePhoneNumberSuccess,
  updatePhoneNumberFailed,
  UPDATE_PHONE_NUMBER_START,
} from '../../actions/accountProfile'

/**
 * update phone number api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const updatePhoneNumberAccountApi = (props) => {
  var uri = `/api/user/phoneverify`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdatePhoneNumber(action) {
  try {
    const response = yield call(updatePhoneNumberAccountApi, action?.payload)
    yield put(updatePhoneNumberSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }

  } catch (error) {
    yield put(updatePhoneNumberFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch update phone number
 */
export default function* watchUpdatePhoneNumber() {
  yield takeLatest(UPDATE_PHONE_NUMBER_START, doUpdatePhoneNumber)
}
